import { Locale } from '../enums'
import { logger } from '../services'
import loadPolyFills from './polyfills'

loadPolyFills()
  .then(() => {
    logger.info('Loaded polyfills...')
  })
  .catch((error) => {
    logger.error('Error loading polyfills', error)
  })

const translations = {
  [Locale.Spanish]: {
    LOGIN_MESSAGE: '¡Te damos la bienvenida!',
    SHARP_ID: 'Sharp ID',
    SHARP_ID_PLACEHOLDER: 'Ingresa tu Sharp ID',
    PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
    NEED_HELP: '¿Necesitas ayuda?',
    NO_LINK: 'No recibí link de recuperación',
    EMAIL: 'Correo Electrónico',
    EMAIL_PLACEHOLDER: 'Ingresa tu correo electrónico',
    HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
    ID_DOCUMENT: 'Documento de Identidad',
    ID_DOCUMENT_TIP:
      'Ingresa aquí tu documento de identidad nacional (DNI,CC,CURP)',
    NO_ACCOUNT: 'Aun no tengo una cuenta',
    VERIFICATION_CODE: 'Código de verificación',
    INVALID_BIRTH_DATE_ERROR: 'Fecha de nacimiento o link inválidos.',
    CODE_VERIFICATION_SUCCESS: 'Tu cuenta ha sido verificada correctamente.',
    USER_REGISTERED_SUCCESS:
      'Te hemos enviado un corre con el código de verificación para que puedas activar tu cuenta.',
    ERROR_REGISTERING_USER: 'Hubo un error al intentar registrar el usuario.',
    EMPLOYEE_ID: 'ID de Empleado',
    SIGN_UP: 'Registrarme',
    VERIFY_CODE: 'Verificar Código',
    VERIFY_CODE_MESSAGE:
      'Ahora selecciona tu fecha de nacimiento para verificar tu cuenta.',
    CALCULATE_YOUR_COMPENSATION: 'Calcula tu compensación',
    WITHDRAW_YOUR_SALARY_WITH_MINU: 'Retira tu salario con minu',
    REVIEW_VACATIONS: 'Estatus de vacaciones',
    BIRTH_DATE: 'Fecha de Nacimiento',
    BIRTH_DATE_PLACEHOLDER: 'Selecciona tu fecha de nacimiento',
    MY_COMPENSATION: 'Mi compensación',
    YOUR_COMPENSATION: 'Tu compensación',
    VACATIONS: 'Vacaciones',
    BENEFITS: 'Beneficios',
    BENEFITS_INSTRUCTIONS:
      'Selecciona una categoría o busca por una palabra clave para empezar a disfrutar de grandes beneficios y descuentos.',
    CERTIFICATES: 'Certificados',
    ERROR_FETCHING_COMPENSATION:
      'Hubo un error al intentar descargar la información de compensación.',
    ERROR_FETCHING_BONUS:
      'Hubo un error al intentar descargar la fórmula del bono de compensación.',
    COMPENSATION_P:
      'Conoce los detalles de tu compensación anual. Este cálculo es una estimación aproximada, la cual depende de los datos que ingreses.',
    COMPENSATION_ITEM1: 'Ingresa tu salario base mensual',
    USER_SUPPORT: 'Soporte al usuario',
    MY_PAYROLL_RECEIPT: 'Mi recibo de nómina',
    GRATIFICATIONS: 'Gratifications',
    VIEW_BENEFITS: 'Ver beneficios',
    CALCULATE_BONUS: 'Calcular Bono STI',
    RESULTS: 'Resultados',
    NO_RESULTS_INSTRUCTIONS:
      'No encontramos resultados para “{textFilter}”. Revisa la ortografía o usa palabras más generales.',
    START_AGAIN: 'Volver a empezar',
    BENEFIT: 'Beneficio',
    AGREEMENT: 'Convenio',
    BENEFITS_MODAL_TITLE1: '¿Qué es un beneficio?',
    BENEFITS_MODAL_TEXT1:
      'Los beneficios los recibes por ser parte de la compañía y se incluyen dentro de tu oferta laboral.',
    BENEFITS_MODAL_TITLE2: '¿Qué es un convenio?',
    BENEFITS_MODAL_TEXT2:
      'Los convenios son descuentos a los que puedes acceder con empresas externas por ser parte de ABI.',
    PROVIDER: 'Proveedor',
    CONTACT: 'Contacto',
    VIEW_MORE_BENEFITS: 'Ver más beneficios',
    PHONE: 'Teléfono',
    ADDRESS: 'Dirección',
    WEBSITE: 'Página web',
    MY_PROFILE: 'Mi Perfil',
    COMPANY: 'Compañía',
    VICE_PRESIDENCY: 'Vicepresidencia',
    AVATAR_UPLOAD_SUCCESS: 'Tu foto de perfil se ha actualizado correctamente.',
    AVATAR_UPLOAD_ERROR:
      'Hubo un error al intentar actualizar tu foto de perfil.',
    UPDATE_PICTURE: 'Actualizar foto',
    EDIT_PROFILE: 'Editar perfil',
    REPORT_ERROR: 'Reportar error',
    REPORT_ERROR_TITLE: '¿Algún error en tu información personal?',
    REPORT_ERROR_TEXT: 'Cuéntanos, ¿en dónde está el problema?',
    REPORT_ERROR_INSTRUCTION: 'DESCRIBE EL ERROR',
    REPORT_ERROR_PLACEHOLDER:
      'Hola! Encontré un error en mi información personal en la plataforma…',
    REPORT_ERROR_ERROR: 'Hubo un error al intentar enviar el reporte de error.',
    ERROR_REPORT_SENT_TITLE: '¡Gracias por tu reporte!',
    ERROR_REPORT_SENT_BODY:
      'Nuestro equipo de soporte revisará la información disponible para actualizar tu información lo más pronto posible.',
    EDIT_PROFILE_SUCCESS:
      'Tu perfil ha sido actualizado correctamente. Si has cambiado tu email, Te enviaremos un correo con instrucciones para su confirmación.',
    EDIT_PROFILE_ERROR: 'Hubo un error al intentar actualizar tu perfil.',
    SAVE_CHANGES: 'Guardar cambios',
    MY_PREFERRED_NAME: 'Mi nombre preferido',
    CANCEL: 'Cancelar',
    CHANGE_PWD: 'Cambiar contraseña',
    CURRENT_PWD: 'Contraseña actual',
    CHANGING: 'Cambiando',
    ERROR_FETCHING_CATEGORIES:
      'Hubo un error al intentar obtener las categorías de beneficios.',
    ERROR_FETCHING_BENEFITS:
      'Hubo un error al intentar obtener los beneficios.',
    CALCULATE: 'Calcular',
    MONTHS: 'Meses',
    CALCULATE_COMPENSATION: 'Calcular Compensación',
    ANNUAL_TOTAL: 'Total Anual',
    MONTHLY_SALARY_BASE: 'Salario Base Mensual',
    MONTHLY_SALARY_BASE_HELP:
      'El pago base que recibes mensualmente por tu trabajo.',
    BAND_HELP: 'Es un rango de salarios para cada nivel dentro de ABI.',
    TOTAL_ACHIEVEMENT_SCORE_HELP:
      'Es el porcentaje que tiene en cuenta los resultados globales, de la BU y tus metas individuales anuales.',
    BONUS_TARGET_HELP:
      'Es el porcentaje fijo del MRS (Salario de Referencia de Mercado) en relación a la banda que tenga tu posición y lo determina el equipo de Global Rewards. El porcentaje varía de acuerdo a la banda.',
    MARKET_REFERENCE_SALARY_HELP:
      'Es el pago anual base que paga una posición de acuerdo a la Mediana del Mercado. Cada banda tiene su propio MRS.',
    BONUS_SIMULATOR: 'Simulador del bono STI',
    BONUS_ESTIMATION: 'Tu bono estimado',
    TOTAL_ACHIEVEMENT_SCORE: 'Total Achievement Score',
    INDIVIDUAL_ACHIEVEMENT: 'Individual Achievement',
    INDIVIDUAL_ACHIEVEMENT_HELP:
      '(Metas individuales) Están compuestas por tipos de metas numéricas, nominales, de proyecto o dashboard que se calculan según el resultado asignado a tu función. Si eres banda I a IV debes obtener un mínimo de 35% para que seas elegible al bono, mientras que si eres banda V o superior el mínimo es de 50%.',
    DISCRETIONARY_INCENTIVE: 'Discretionary Incentive',
    DISCRETIONARY_INCENTIVE_HELP:
      'Es un incentivo determinado por el vicepresidente de cada función para retener el talento.  Se distribuye según criterios de meritocracia, donde el 15% de la población podría tener entre el 20% y el 30% adicional de bono, donde este excedente es financiado del bono de personas con bajo desempeño.',
    SIZE_OF_THE_PIE: 'Size of the Pie',
    SIZE_OF_THE_PIE_HELP:
      'Determina la cantidad de fondos que están disponibles para la bonificación y se calcula por el crecimiento orgánico del EBITDA. Va desde el 40% al 160%.',
    ENTITY_PERFORMANCE: 'Entity Performance',
    ENTITY_PERFORMANCE_HELP:
      'Es la contribución de la entidad al desempeño general de la empresa.',
    ENJOY_YOUR_BENEFITS: 'Disfrutar de tus beneficios',
    CALCULATE_BONUS_STI: 'Calcula tu Bonus STI',
    YOUR_PAYROLL_RECEIPTS: 'Recibos de nómina',
    YOUR_EMPLOYMENT_CERTIFICATES: 'Certificados laborales',
    VACATION_DAYS: 'Días de vacaciones',
    ANNUAL_VACATION_DAYS: 'Días de vacaciones al año',
    ANNUAL_VACATION_DAYS_HELP:
      'Ingresa los días de vacaciones a los que tengas derecho actualmente de acuerdo a tu antigüedad. Esto nos ayuda a calcular tu prima vacacional.',
    EMAIL_CHANGE_SUCCESS:
      'Tu nuevo email ha sido correctamente verificado en la plataforma.',
    EMAIL_CHANGE_ERROR:
      'Hubo un error al intentar verificar tu cambio de email en la plataforma.',
    EMAIL_CHANGE_UNAUTHORIZED:
      'El link para verificar tu cambio de email ha vencido, debes volver a hacer la solicitud y verificar el cambio nuevamente.',
    WAIT_VERIFY_EMAIL:
      'Por favor espera mientras verificamos el cambio de tu email.',
    BENEFITS_TOTAL: 'Total Beneficios',
    BENEFITS_P:
      'Los siguientes valores representan el costo de algunos de los beneficios que recibes por parte de la compañía.',
    BENEFITS_P2:
      'Consulta la lista completa de beneficios y convenios en la sección de Beneficios.',
    BONUS_STI_TOTAL: 'Total Bono STI',
    BONUS_SIMULATOR_P:
      'El incentivo de corto plazo es el valor que la compañía reconoce a sus trabajadores con el pago de días adicionales de salario de acuerdo al Achievement Score del área a la que perteneces. Este cálculo es una simulación. Puedes generar distintos estimados dependiendo de los valores ingresados.',
    CALCULATE_SCORE: 'Calcular Score',
    TIME_DEDICATION_RATE_P1:
      'Es el tiempo que tienes dentro de ese período en la compañía.',
    TIME_DEDICATION_RATE_P2: 'Los empleados no son elegibles para bono si:',
    TIME_DEDICATION_RATE_P2_1:
      'Salen de la empresa voluntariamente antes del 31 de diciembre del año en curso.',
    TIME_DEDICATION_RATE_P2_2:
      'Entra a la compañía a partir del 1 de octubre del año del año en curso.',
    TIME_DEDICATION_RATE_P2_3:
      'Son despedidos por motivos éticos, de cumplimiento o disciplinarios.',
    TIME_DEDICATION_RATE_P2_4:
      'Salen de la compañía antes de haber trabajado al menos 6 meses.',
    TIME_DEDICATION_RATE_P3: 'Reglas de Elegibilidad de Ingreso',
    TIME_DEDICATION_RATE_P3_1:
      'Si el empleado ingresa a la empresa o es elegible para el bono por primera vez antes del 31 de marzo, el bono se calculará por el 100% del año.',
    TIME_DEDICATION_RATE_P3_2:
      'Si el empleado ingresa a la empresa o es elegible para el bono por primera vez desde el 1 de abril hasta el 30 de septiembre, el bono se calculará por la proporción del año que ha trabajado. Ej: Si trabajó desde Julio 1 será elegible al 50% del bono porque está el 50% del tiempo.',
    TIME_DEDICATION_RATE_P4: 'Reglas de Elegibilidad de Cambio de posición',
    TIME_DEDICATION_RATE_P4_1: 'Si el empleado cambia de posición.',
    TIME_DEDICATION_RATE_P4_2:
      'Antes del 1 de marzo, el 100% de su bono STI será calculado con las nuevas metas.',
    TIME_DEDICATION_RATE_P4_3:
      'Entre 1 de abril al 30 de septiembre, el cálculo de su bono será proporcional por el tiempo que tuvo las metas iniciales y por el tiempo que tiene de las nuevas metas.',
    TIME_DEDICATION_RATE_P4_4:
      'Ambos espacios se calcularán con la banda que tiene al 30 de septiembre.',
    TIME_DEDICATION_RATE_P4_5:
      'Después de 1 de octubre, el cálculo del 100% del bono será en base a las metas anteriores y con la banda que tiene al 30 de septiembre.',
    STI_FORMULA: 'Formula del STI',
    STI_FORMULA_HELP:
      'Esta herramienta fue diseñada para ayudar a la comprensión del cálculo del bono anual y proveer una estimación en base a los resultados individuales y de la compañía.  Estas simulaciones no comprometen a la empresa a pago alguno y son valores brutos, es decir, no calculan la deducción de impuestos de ley respectivos.  El bono anual del ejercicio económico se pagará en Marzo del siguiente año, si hubiere.  La empresa se reserva el derecho de cambiar las fórmulas o variables del bono anual cuando lo considere necesario.',
    STI_FORMULA_P: 'Así es como se calcula tu bono:',
    ANNUAL_TOTAL_HELP:
      'Esta herramienta fue diseñada para ayudar a la comprensión del cálculo de la Compensación Total Anual de cada empleado. Estas simulaciones no comprometen a la empresa a pago alguno y son valores brutos, es decir, no calculan la deducción de impuestos de ley respectivos.  La empresa se reserva el derecho de cambiar el modelo de Compensación cuando lo estime conveniente.',
    BENEFITS_TOTAL_HELP:
      'Los valores correspondientes a los beneficios son una referencia del costo de los mismos por empleado. La no entrega de alguno no compromete a la Empresa para el pago del mismo. La empresa se reserva el derecho de cambiarlos cuando lo estime conveniente.',
    PLEASE_SELECT_COUNTRY: 'Por favor elige tu país:',
    PORTAL_INSTRUCTIONS: 'Instrucciones del portal',
    CATEGORY_BACK: 'Regresar a categorías',
    FORMAT: 'Formato',
    CONTROL_PANEL: 'Panel de Control',
    ADMINISTRATION_PANEL: 'Administrador',
    USER_MANAGEMENT: 'Gestión de Usuarios',
    UPLOAD_COLLABORATORS: 'Cargar Colaboradores',
    UPLOAD_EXITS: 'Cargar Salidas',
    USER_ADMIN_P1: 'Busca usuarios por ID, por nombre o utiliza los filtros.',
    USER_SEARCH_INSTRUCTIONS: 'Busca usuarios por nombre o por ID.',
    PERFORM_USER_SEARCH: 'Realiza una búsqueda de usuarios',
    ROLE: 'Rol',
    FILTER: 'Filtrar',
    SELECT_COUNTRY: 'Selecciona el País',
    NONE: 'Ninguno',
    CHANGE_ROLE: 'Cambiar rol',
    DELETE_USERS: 'Eliminar usuarios',
    DELETE_USERS_CONFIRMATION:
      '¿Estás seguro de que quieres eliminar a los usuarios seleccionados de manera permanente?',
    CHANGE: 'Cambiar',
    CHANGE_ROLE_CONFIRMATION:
      '¿Estás seguro de que quieres cambiar el rol a los usuarios seleccionados?',
    ERROR_FETCHING_USERS: 'Hubo un error al intentar obtener los usuarios.',
    DELETE_USERS_SUCCESS: 'Los usuarios han sido eliminados de la plataforma.',
    DELETE_USERS_ERROR:
      'Hubo un error al intentar borrar los usuarios de la plataforma.',
    SUCCESSFUL_UPLOAD: 'Carga exitosa',
    COLLABORATORS_REPORT_SUCCESS:
      'El reporte de colaboradores ha sido cargado exitosamente a la plataforma.',
    UNDERSTOOD: 'Entendido',
    EXITS_REPORT_SUCCESS:
      'El reporte de salidas ha sido cargado exitosamente a la plataforma.',
    COMPENSATION_DISCLAIMER:
      'Simulación basada en un empleado con nómina local. Resultados antes de impuestos. Dato de uso informativo, no oficial',

    //
    HELP: 'Ayuda',
    HELP_P1:
      'Para dudas sobre el uso de la herramienta, por favor consulta <a>los tutoriales</a> que creamos para ti.',
    HELP_P2:
      'Si después de ver los tutoriales aún tienes alguna duda o problema, ¡contáctanos! Por favor ayúdanos a reportar tu error en <a>este formulario</a> y te contácteremos para resolverlo.',
    HELP_P3:
      'Para dudas o soporte no resueltos a través de las opciones anteriores, dirígete a <a>SAM Portal</a> y abre un ticket. ¡Te atenderemos lo más pronto posible!',
    HELP_TITLE: '¿Cómo podemos ayudarte?',
    HOME: 'Inicio',
    PENDING: 'Pendientes',
    LOCATION: 'Localidad',
    COMPLETED_INTERVIEW: 'Entrevista Completada',
    REQUEST_HELP: 'Solicitar Ayuda',
    HELP_MAIL_SUBJECT: 'Solicitud de Ayuda +BeneFi',
    HELP_MAIL_BODY: `Hola, parece que estás teniendo problemas en nuestro portal +BeneFi.
Por favor describe detalladamente cuál es el error, así nuestro equipo de soporte podrá buscar una solución lo más pronto posible.

Gracias por contactarte con nosotros, estamos para ayudarte.

Cordialmente,
Equipo Simplifica Maz`,
    PASSWORD_CHANGE_WARNING:
      'Tu contraseña está próxima a vencer. Debes cambiarla {days, plural, =1 {hoy mismo} other {en los siguientes # días}}.',
    PASSWORD_BLOCKED_ERROR:
      'Tu login ha sido bloqueado temporalmente por múltiples intentos fallidos. Podrás volver a intentarlo en {minutes, plural, =0 {menos de un minuto} =1 {un minuto} other {# minutos}}.',
    PASSWORD_VOID_ERROR:
      'Tu contraseña actual ha vencido, debes cambiarla por medio del mecanismo de olvido de contraseña para poder recuperar el acceso a la plataforma.',
    INACTIVITY_WARNING:
      'Esta sesión se cerrará automáticamente por inactividad en {minutes} minutos.',
    REPORT_UPLOAD_SUCCESS:
      'El reporte ha sido cargado correctamente y está siendo procesado.',
    REPORT_UPLOAD_ERROR:
      '¡Lo sentimos! Hubo un error cargando al cargar el reporte.',
    REPORT_LOAD_INSTRUCTIONS:
      'Arrastra y suelta el archivo del reporte o haz click aquí',
    UPLOAD_REPORT: 'Cargar reporte',
    REPORT_LOAD: 'Carga de Reporte',
    ADMINISTRATION: 'Admin',
    EXISTING_USER: 'Usuario Existente',
    ALL: 'Todas',
    GREETING: '¡Hola {firstName}!',
    INIT_QUESTION: '¿Qué quieres hacer?',
    LOADING: 'Cargando...',
    USER: 'Usuario',
    PASSWORD: 'Contraseña',
    OLD_PWD: 'Contraseña antigua',
    MY_PWD: 'Mi contraseña',
    SAVE_PWD: 'Guardar contraseña',
    CLOSE_SESSION: 'Cerrar sesión',
    FORGOT_PWD: '¿Olvidaste tu contraseña?',
    INIT_SESSION: 'Iniciar Sesión',
    RETURN: 'Regresar',
    SEND: 'Enviar',
    SEND_LINK: 'Enviar Link',
    NEW_PWD: 'Nueva Contraseña',
    NEW_PWD_PLACEHOLDER: 'Crea una nueva contraseña',
    REPEAT_NEW_PWD: 'Confirmación de contraseña',
    RECOVER_PWD: 'Recuperar contraseña',
    FORGOT_PWD_MESSAGE:
      'No hay problema. Escribe tu correo y te enviaremos un link de recuperación.',
    PASSWORD_RECOVERY_MESSAGE:
      'Tu contraseña ha sido actualizada exitosamente.',
    FORGOT_PWD_NOTIFICATION:
      'Hemos enviado a tu correo las instrucciones para recuperar tu contraseña.',
    NAME_OR_ID: 'Nombre / ID',
    VIEW_REPORT: 'Consultar reporte',
    THANK_YOU: '¡Gracias!',
    EARLY_ENDING: 'Aquí concluye esta entrevista.',
    ACCEPT: 'Aceptar',
    CONTINUE: 'Continuar',
    BACK: 'Atrás',
    REGISTER: 'Registrar',
    APPLY_INTERVIEW: 'Aplicar entrevista',
    YES: 'Si',
    NO: 'No',
    FINISH: 'Finalizar',
    SELECT: 'Seleccione',
    JUSTIFICATION: 'Justificación',
    ARE_YOU_SURE: '¿Estás seguro(a)?',
    SAVING: 'Guardando',
    FROM: 'Desde',
    UNTIL: 'Hasta',
    DOWNLOAD: 'Descargar',
    GENERATING_DOWNLOAD: 'Generando descarga...',
    REPORTS: 'Reportes',
    USER_MANUAL: 'Manual de usuario',
    USERS: 'Usuarios',
    ADD: 'Añadir',
    EDIT: 'Editar',
    DELETE: 'Eliminar',
    ERROR_SESSION:
      '¡Oh! No pudimos iniciar sesión con tu usuario, intenta nuevamente.',

    TERMS_AND_CONDITIONS: 'Términos y Condiciones',
    PRIVACY_POLICY: 'Política de Privacidad',
    COPYRIGHT:
      'Todos los derechos reservados {year}. ©{year}ANHEUSER-BUSCH INBEV S.A.',

    NEW_INTERVIEW_STATUS: 'Registro - paso 1 / 3',
    NEW_INTERVIEW: 'Nueva entrevista',
    APPLICATION_DATE: 'Fecha de aplicación',
    EMPLOYEE_NAME: 'Nombre del colaborador',
    SEX: 'Sexo',
    LINE_MANAGER: 'Line Manager',
    BAND: 'Banda',
    POSITION: 'Posición',
    COUNTRY: 'País',
    UEN: 'UEN',
    VP: 'Vicepresidencia / Área',
    VP_SHORT: 'VP / Área',
    HIRING_DATE: 'Fecha de Ingreso',
    OPR_RATING: 'Calificación OPR',
    EXIT_DATE: 'Fecha de salida',
    EXIT_TYPE: 'Tipo de salida',
    AGREED_TO_INTERVIEW: '¿Accedió a la entrevista?',
    EDIT_INFO: 'Editar información',
    VOLUNTARY: 'Voluntaria',
    INVOLUNTARY: 'Involuntaria',
    BP_OBSERVATIONS: 'Observaciones de Business Partner',

    INTERVIEW_INSTRUCTIONS_STATUS: 'Cuestionario - paso 2 / 3',
    INTERVIEW_INSTRUCTIONS_TITLE:
      'Estás a punto de pasar a la sección de preguntas.',
    INTERVIEW_INSTRUCTIONS_HEAD:
      'Recuerda que tu trabajo es ser embajador de la cultura AB InBev hasta el último momento, por lo que es importante que consideres lo siguiente para hacer esta entrevista lo más humanamente posible:',
    INTERVIEW_INSTRUCTIONS_POINT_1:
      'Menciónale cuánto apreciamos toda la experiencia que compartió con la compañía y el tiempo que está tomándose para contestar nuestras preguntas.',
    INTERVIEW_INSTRUCTIONS_POINT_2:
      'Asegúrale que esta información es 100% confidencial. Esto significa que nadie además de ti conocerá las respuestas, por lo que no existe ninguna clase de represalias y esto de ninguna manera influirá en posibles referencias laborales que nos sean pedidas sobre él/ella.',
    INTERVIEW_INSTRUCTIONS_POINT_3:
      'Hazle saber que la entrevista tiene el propósito de encontrar áreas de oportunidad que nos ayuden a hacer de AB InBev una mejor empresa para trabajar.',
    INTERVIEW_INSTRUCTIONS_BOTTOM:
      'Una vez concluida la entrevista, es de suma importancia que agradezcas una vez más por su tiempo, sus respuestas y su honestidad; además de desearle mucha suerte en sus proyectos futuros.',

    QUESTIONARY_STATUS: 'Cuestionario - paso 2 / 3',
    QUESTIONARY_TITLE: 'Entrevista de salida',
    QUESTIONARY_EXPLANATION:
      'Selecciona la respuesta correspondiente a lo dicho por el colaborador y brinda comentarios cuando sea necesario en el espacio indicado.',
    QUESTIONARY_CONFIRMATION:
      'Una vez que finalices la entrevista, no podrás editar las respuestas de esta sección.',
    QUESTIONARY_THANKS_TITLE: '¡Muchas gracias',
    QUESTIONARY_THANKS_SUB_TITLE: 'por tu tiempo y tu colaboración!',

    // Common Options
    NA: 'N.A.',
    ALWAYS: 'Siempre',
    ALMOST_ALWAYS: 'Casi siempre',
    SOMETIMES: 'Algunas veces',
    ALMOST_NEVER: 'Casi nunca',
    NEVER: 'Nunca',
    // Motive Options
    QUESTIONARY_MOTIVE_NA: 'N.A.',
    QUESTIONARY_MOTIVE_INCOME: 'Salario / Sueldo',
    QUESTIONARY_MOTIVE_BENEFITS: 'Beneficios',
    QUESTIONARY_MOTIVE_WORK_CENTER: 'Centro de trabajo',
    QUESTIONARY_MOTIVE_WORK_ENVIRONMENT: 'Ambiente laboral',
    QUESTIONARY_MOTIVE_COMPANY_CULTURE: 'Cultura de la compañía',
    QUESTIONARY_MOTIVE_COMPANY_PRESTIGE: 'Prestigio de la compañía',
    QUESTIONARY_MOTIVE_POSITION: 'Función / Puesto',
    QUESTIONARY_MOTIVE_OTHERS: 'Otros',
    // Exit Motive Options
    EXIT_MOTIVE_NA: 'N.A. (salidas involuntarias)',
    EXIT_MOTIVE_IMMEDIATE_LEADER: 'Líder inmediato',
    EXIT_MOTIVE_INCOME: 'Salario/Sueldo',
    EXIT_MOTIVE_LACK_OF_PROFESSIONAL_GROWTH: 'Falta de crecimiento profesional',
    EXIT_MOTIVE_LIFE_WORK_BALANCE: 'Balance vida - trabajo',
    EXIT_MOTIVE_COMPANY_CULTURE: 'Cultura de la compañía',
    EXIT_MOTIVE_COMPANY_LEADERSHIP: 'Liderazgo de la compañía',
    EXIT_MOTIVE_COMPANY_PRESTIGE: 'Prestigio/reputación de AbInBev',
    EXIT_MOTIVE_WORK_ENVIRONMENT: 'Ambiente laboral',
    EXIT_MOTIVE_RESPECT_AND_INCLUSION: 'Respeto e inclusión',
    EXIT_MOTIVE_LACK_OF_TRAINING: 'Falta de capacitación/desarrollo',
    EXIT_MOTIVE_SECURITY_OF_WORK_CENTER:
      'Condiciones de seguridad en mi centro de trabajo',
    EXIT_MOTIVE_LACK_OF_RESOURCES_FOR_JOB:
      'Falta de recursos necesarios para hacer mi trabajo',
    EXIT_MOTIVE_DISLIKE_OF_JOB_TASKS: 'Disgusto con las tareas de tu función',
    EXIT_MOTIVE_PERSONAL_SITUATION: 'Situación personal',
    EXIT_MOTIVE_OTHER: 'Otro',
    EXIT_MOTIVE_SUM_OTHERS: 'Suma (otros motivos)',

    PRE_FEEDBACK_STATUS: 'Retroalimentación a LM - paso 3 / 3',
    PRE_FEEDBACK_CONTINUE: 'Continuar a retroalimentación',
    FEEDBACK: 'Retroalimentación',
    EXIT: 'Salir',
    PRE_FEEDBACK_TEXT_1:
      'Ahora es momento de brindar una sesión de retroalimentación al Line Manager de nuestro ex colaborador.',
    PRE_FEEDBACK_TEXT_2:
      'En el siguiente apartado encontrarás un espacio para registrar lo acontecido durante esta sesión. Puedes completarla ahora o  hacerlo más tarde, accediendo a ella desde el apartado  “Entrevistas pendientes” del Menú.',
    PRE_FEEDBACK_QUESTION: '¿Qué deseas hacer?',

    FEEDBACK_STATUS: 'Retroalimentación a LM - paso 3 / 3',
    FEEDBACK_TITLE: 'Retroalimentación a Line Manager',
    FEEDBACK_EXPLANATION:
      'Completa los campos que se presentan a continuación. Recuerda que <b>toda la información que llenes en esta sección será compartida directamente con tu Line Manager</b>.',
    FEEDBACK_ACTION_PRE_EXPLANATION: 'Descripción general del Plan de Acción',
    FEEDBACK_ACTION_POST_EXPLANATION:
      'Recuerda que este plan deberá ser ejecutado en el Plan de Acción de Engagement actual',
    FEEDBACK_BUTTON: 'Enviar a LM',
    FEEDBACK_CONFIRMATION:
      'Una vez que envíes a LM, la información no podrá modificarse a menos que él/ella así lo solicite',

    READY: '¡Listo!',
    FEEDBACK_SENT_PARAGRAPH_1:
      'Hemos enviado un correo al Line Manager donde podrá corroborar esta información.',
    FEEDBACK_SENT_PARAGRAPH_2:
      'Una vez nos dé su confirmación, la entrevista habrá concluido satisfactoriamente. Te notificaremos cuando esto suceda.',

    NOTICE_CONFIRMED_PARAGRAPH_1:
      'La entrevista de salida con ID <strong>{interviewId}</strong> ha concluido satisfactoriamente.',
    NOTICE_CONFIRMED_PARAGRAPH_2:
      'Gracias por ayudarnos a hacer de ABI un mejor lugar para trabajar.',

    NOTICE_DECLINED_PARAGRAPH_1:
      'Hemos avisado a tu Business Partner que no estás de acuerdo con lo establecido en tu retroalimentación para que revise tu situación.',
    NOTICE_DECLINED_PARAGRAPH_2:
      'Te pedimos intentes contactarlo tan pronto como sea posible.',
    NOTICE_DECLINED_THANKS: '¡Gracias por tu cooperación!',

    LM_FEEDBACK_SENT_SUCCESS:
      'Tu respuesta ha sido enviada correctamente. ¡Gracias por tu ayuda!',
    LM_FEEDBACK_ALREADY_SENT_ERROR:
      'Ya has decidido sobre la sesión de feedback.',
    LM_FEEDBACK_SENT_ERROR:
      '¡Lo sentimos! Ha ocurrido un error al intentar enviar tu respuesta.',

    /**
     * History
     */
    HISTORY: 'Historial',
    INTERVIEW_COUNT:
      '{interviewCount, plural, =0 {No has realizado ninguna entrevista} =1 {Has realizado 1 entrevista} other {Has realizado # entrevistas}} hasta el momento.',
    HISTORY_INSTRUCTIONS:
      'Para consultarlas filtra por rango de fechas o busca por nombre o ID del colaborador.',

    HISTORY_COLUMN_SHARP: 'ID',
    HISTORY_COLUMN_EMPLOYEE: 'Empleado',
    HISTORY_COLUMN_LINE_MANAGER: 'Line Manager',
    HISTORY_COLUMN_CREATED_AT: 'Fecha de creación',
    HISTORY_COLUMN_INTERVIEWER: 'Entrevistador',
    HISTORY_COLUMN_COUNTRY: 'País',
    HISTORY_COLUMN_VICE_PRESIDENCY: 'VP / Área',
    HISTORY_COLUMN_UEN: 'UEN',
    HISTORY_COLUMN_STATUS: 'Estado',

    HISTORY_ROW_DISPLAY: '{from}-{to} de {count}',
    PENDING_INTERVIEWS: 'Entrevistas pendientes',
    NO_PENDING_INTERVIEWS: 'Tienes 0 entrevistas pendientes.',

    INTERVIEW_STATUS_REGISTERED: 'Registrada',
    INTERVIEW_STATUS_INTERVIEW: 'Entrevista',
    INTERVIEW_STATUS_FEEDBACK: 'Retroalimentación a LM',
    INTERVIEW_STATUS_FEEDBACK_SENT: 'Retroalimentación enviada',
    INTERVIEW_STATUS_FEEDBACK_REJECTED: 'Rechazado - LM',
    INTERVIEW_STATUS_FEEDBACK_ACCEPTED: 'Completado - LM',
    INTERVIEW_STATUS_FEEDBACK_NOT_CONFIRMED: 'Completado',

    /**
     * Reports
     */
    REPORTS_INSTRUCTIONS:
      'Selecciona la información que necesites para generar una gráfica',
    PARAMETER: 'Parámetro',
    PERIOD: 'Periodo',
    SHOW_BY: 'Mostrar por',
    OPTIONAL: 'Opcional',
    GENERATE_CHART: 'Generar gráfica',
    GENERATING: 'Generando...',
    REPORT_TYPE_KPI: 'Cumplimiento KPI',
    REPORT_TYPE_SLA: 'Motivos de salida',
    START_DATE: 'Fecha Inicial',
    END_DATE: 'Fecha Final',
    UPDATE_DATE: 'Actualización',
    ZONE: 'Zona',
    ANOTHER_REPORT: '¿Necesitas otro reporte?',
    ANOTHER_REPORT_SUB: 'Descarga el archivo de Excel que necesites.',
    DOWNLOAD_REPORT: 'Descargar reporte',
    DOWNLOAD_IMAGE: 'Descargar imagen',
    COMPLETED: 'Completadas',
    UNANSWERED: 'Sin contestar',
    IN_PROGRESS: 'En progreso',
    REPORT_TYPE_KPI_TITLE: 'KPI',
    COMPLIANCE_PERCENTAGE: '% de cumplimiento',
    REPORT_TYPE_SLA_TITLE: 'Motivos de salida',

    /**
     * Admin
     */
    ADMIN_SEARCH_INSTRUCTIONS:
      'Escribe aquí el o los IDs de los usuarios que quieras agregar separándolos por una coma. Da enter al terminar',
    USER_ADMIN_COLUMN_SHARP: 'ID',
    USER_ADMIN_COLUMN_NAME: 'Nombre',
    USER_ADMIN_COLUMN_COUNTRY: 'País',
    USER_ADMIN_COLUMN_UEN: 'Compañía',
    USER_ADMIN_COLUMN_EMAIL: 'Email',
    USER_ADMIN_COLUMN_ROLE: 'Rol',
    SUBMITTING_ADD: 'Añadiendo...',
    SUBMITTING_EDIT: 'Modificando...',
    SUBMITTING_DELETE: 'Eliminando...',
    USERS_UPDATE_SUCCESS:
      'Los usuarios seleccionados han sido actualizados correctamente.',
    USERS_UPDATE_ERROR:
      '¡Lo sentimos! Hubo un error al intentar actualizar los usuarios seleccionados.',

    USER_ROLE_ADMINISTRATOR: 'Administrador',
    USER_ROLE_REGULAR: 'Colaborador',
    USER_ROLE_INVALID: 'Eliminado',

    IMG_LOAD_INSTRUCTIONS: 'Arrastra y suelta la imagen o haz click aquí',

    /**
     * Autocomplete
     */
    AUTOCOMPLETE_NO_OPTIONS: 'No hay opciones para la búsqueda.',
    AUTOCOMPLETE_INSTRUCTIONS: 'Empieza a escribir para buscar',

    /**
     * Validation
     */
    VALIDATE_EMAIL: 'El email que has ingresado no es valido.',
    VALIDATE_TERMS: 'Debes aceptar los términos y condiciones.',
    VALIDATE_POLICY: 'Debes aceptar la política de privacidad.',
    VALIDATE_REQUIRED_GENERIC: 'Este campo es requerido.',
    VALIDATE_REQUIRED: '{fieldName} es un campo requerido.',
    VALIDATE_PWD_NOT_NEW:
      'La nueva contraseña debe ser diferente de la contraseña actual.',
    VALIDATE_PWD_MATCH: 'Las contraseñas deben coincidir.',
    VALIDATE_MIN_LENGTH:
      '{fieldName} debe tener al menos {minLength} caracteres.',
    VALIDATE_PWD_INSTRUCTIONS:
      'Debe tener al menos {length} caracteres, un número, una minúscula, una mayúscula y un símbolo (. @ $ ! % * # ? & -)',
    VALIDATE_CREDENTIALS_ERROR: 'Contraseña o usuario incorrectos.',
    VALIDATE_CURRENT_PWD: 'La contraseña actual es incorrecta.',
    VALIDATE_MUST_SELECT_SCOPE: 'Debes seleccionar un scope.',

    /**
     * Messages (toast)
     */
    ERROR_FETCHING_COLLABORATOR:
      '¡Lo sentimos! Hubo un error descargando la información del colaborador.',
    ERROR_CREATING_INTERVIEW:
      '¡Lo sentimos! Hubo un error creando la entrevista.',
    ERROR_FETCHING_STORED_QUESTIONARY:
      '¡Lo sentimos! Hubo un error descargando la información guardada sobre la entrevista.',
    ERROR_SAVING_PARTIAL_QUESTIONARY:
      '¡Lo sentimos! Hubo un error guardando el parcial de las preguntas.',
    ERROR_SAVING_QUESTIONS:
      '¡Lo sentimos! Hubo un error guardando las preguntas.',
    ERROR_FETCHING_STORED_FEEDBACK:
      '¡Lo sentimos! Hubo un error descargando la información guardada sobre el feedback.',
    ERROR_SAVING_PARTIAL_FEEDBACK:
      '¡Lo sentimos! Hubo un error guardando el parcial del feedback.',
    ERROR_SAVING_FEEDBACK: '¡Lo sentimos! Hubo un error guardando el feedback.',
    ERROR_DOWNLOADING_REPORT:
      '¡Lo sentimos! Hubo un error descargando el reporte.',
    ERROR_PAYROLL: '¡Lo sentimos! Hubo un error descargando la información',

    SUCCESS_CREATING_INTERVIEW: 'La entrevista ha sido creada correctamente.',
    SUCCESS_SAVING_QUESTIONS: 'Las preguntas han sido guardadas correctamente',
    SUCCESS_SAVING_FEEDBACK: 'El feedback ha sido guardado correctamente.',

    BUSINESS_UNIT_CAC: 'CAC',
    BUSINESS_UNIT_CO: 'Colombia',
    BUSINESS_UNIT_EC: 'Ecuador',
    'BUSINESS_UNIT_HN / SV': 'Honduras / Salvador',
    BUSINESS_UNIT_MEX: 'Mexico',
    BUSINESS_UNIT_PE: 'Perú',

    VP_SALES: 'Ventas',
    VP_FINANCE: 'Finanzas',
    'VP_LEGAL / CORPORATE AFFAIRS': 'Legal',
    VP_LOGISTICS: 'Logística',
    VP_SUPPLY: 'Supply',
    VP_SOLUTIONS: 'Solutions',
    VP_MARKETING: 'Marketing',
    VP_PROCUREMENT: 'Procurement',
    VP_PEOPLE: 'People',
    PHYSICAL: 'Físico',
    SOCIO_EMOTIONAL: 'SocioEmocional',
    FINANCIAL: 'Finaciero',

    MANAGER_BENEFITS: 'Gestion de contenido',

    PILLARFISICO: 'Fisico',

    PAYROLL_NOT_DATA: 'No hay datos asociados, intenta con otra fecha',
    PAYROLL_TITLE: 'Comprobante de nómina',
    TITLE_DESCRIBE: 'Selecciona el mes para descargar tu comprobante de nómina',
    BTN_PAYROLL: 'Consultar',
    PAYROLL_VOUCHER: 'Comprobante',
    PAYROLL_MONTH: 'Mes',
    PAYROLL_SELECTED: 'Seleccione año y mes',
    SESION_MODAL_TITLE: '¡Qué gusto tenerte aquí!',
    SESION_MODAL_DESCRIBE: `Recuerda que si estás en {CO} o {RD}, puedes visitar {EB} o {tap}
    para consultar los beneficios que la compañía tiene para ti.`,
    SESION_MODAL_DESCRIBE_2:
      'Si estás en {MX}, queremos que sepas que seguimos trabajando para habilitar la herramienta y todos puedan acceder.',
    PRIVACY: `ANHEUSER-BUSCH INBEV S.A. PUNTO A PUNTO T2, Cervezas Modelo Nvo. León, Diblo Corporativo, Cervezas Modelo Pacífico, MULTISERVICIOS NAC MODELO, COBRANZA MODELO, Cervezas Modelo Centro, Cervezas Modelo Occidente, Cervezas Modelo en S.L.P., Cervezas Mod.B.California, Cervezas Modelo Zacatecas, Dist.Cervezas en el Norte, Distribuidora de Tabasco, Cervezas Modelo Guerrero, Cerv.Modelo Zona Metrop., Cervezas Modelo en Sonora, Cervezas Modelo del Bajío, Cervezas Modelo Altiplano, Cervezas Modelo Morelos, Cervezas Modelo Campeche, Cervezas Modelo en Oaxaca, Cervezas Modelo Sureste, Cervezas Modelo Hidalgo, Cervezas Modelo Nayarit, Cervezas Modelo Michoacán, Cervezas Modelo Edo.Mex., Inamex Cerveza y Malta, Agencia Modelo del Istmo, Cerv. Mod. de Guadalajara, Cía.Cervecera del Trópico, CERVECERIA YUCATECA, Cerv Modelo (México), Cebadas y Maltas, Cerveceria Modelo Centro Dist. Modelo en Chihuahua, Cervezas Modelo Acapulco Envases de Zacatecas, Cerv. Modelo de Torreón Tapas y Tapones Zacatecas, Cervecería del Pacífico, Cervezas Modelo Noreste Cervezas Modelo Veracruz Cia.Cerv. de Zacatecas, Ind Vidriera del Potosí Dist PacíficoMod Culiacán, ARTESANAS DE MALTA Y CEBA Rancho Cermo, SA de CV Distrib Industrial Cuicha Materiales del Istmo, S.A Ind Decoradora de Envases Empresarios Detallistas d Bavaria S.A. ZX Ventures Colombia Kopps Commercial S.A.S. Cerveceria Union S.A. Cerveceria del Valle S.A. Impresora Del Sur S.A. Indugral Cerv BBC de la Sabana SAS Transportes TEV S.A.S. Cerveceria BBC SAS Fundacion Bavaria La Constancia LTDA DE CV Cerv Hondureña, S.A. Plásticos Indust HN, S.A. Logístic Integral HN S.A. Cervecería Nacional SdeRL MAR DEL SUR LOGÍSTICA, SA PACIFIC BREWERY, S.A. COMPAÑÍA CERVECERA AMBEV UCP BACKUS Y JOHNSTON SAA CERVECERIA SAN JUAN S.A. NAVIERA ORIENTE S.A.C TRANSPORTES 77 S.A. Ambev Centroamerica DINADEC S.A. Cervecería Nacional CN SA Cervecería Nac. Dominican Banks Brewery Banks Holding Limited Barbados Diary Industries Dominica Brewery & Bevera Saint Vincent Brewery & B, todas con Correo electrónico protecciondedatos@co.ab-inbev.com, y teléfono (+571) 6389000 (en adelante LA EMPRESA), cada una individualmente considerada como Responsable del Tratamiento de Datos Personales, para el adecuado desarrollo de sus actividades comerciales, así como para el fortalecimiento de sus relaciones con terceros, recolecta, almacena, usa, circula y suprime Datos Personales correspondientes a personas naturales con quienes tiene o ha tenido relación, tales como, sin que la enumeración signifique limitación, trabajadores y familiares de éstos, accionistas, consumidores, clientes, distribuidores, proveedores, acreedores y deudores.
  Los Datos Personales son objeto de Tratamiento por parte de LA EMPRESA con las siguientes finalidades:

  ● Para el envío de información a sus trabajadores y familiares;

  ● Para la prestación de los servicios de salud a los familiares de los trabajadores de LA EMPRESA beneficiarios del servicio de salud;
                    
  ● Para el reconocimiento, protección y ejercicio de los derechos de los accionistas de LA EMPRESA;
                    
  ● Para el fortalecimiento de las relaciones con sus consumidores y clientes, mediante el envío de información relevante, la toma de pedidos y la atención de Peticiones, Quejas y Reclamos (PQR’s) por parte del área de servicio al cliente, la evaluación de la calidad de su servicio al cliente y la invitación a eventos organizados o patrocinados por LA EMPRESA, entre otros;
                    
  ● Para la interacción con sus Distribuidores, para la verificación del cumplimiento de los estándares de distribución, de sus obligaciones legales con sus trabajadores y para la invitación a eventos organizados o patrocinados por LA EMPRESA, entre otros.
                    
  ● Para consolidar un suministro oportuno y de calidad con sus Proveedores, a través de la invitación a participar en procesos de selección, la evaluación del cumplimiento de sus obligaciones y la invitación a eventos organizados o patrocinados por LA EMPRESA, entre otros;
                    
  ● Para la verificación de saldos de sus acreedores;
                    
  ● Para la determinación de obligaciones pendientes, la consulta de información financiera e historia crediticia y el reporte a centrales de información de obligaciones incumplidas, respecto de sus deudores;
                    
  ● Para mejorar, promocionar y desarrollar sus productos y los de sus compañías vinculadas a nivel mundial;
                    
  ● Para actividades de mercadeo, estadísticas, de investigación y demás propósitos comerciales que no contravengan la legislación vigente;
                    
  ● Para la atención de requerimientos judiciales o administrativos y el cumplimiento de mandatos judiciales o legales.
                    
  ● Para eventualmente contactar, vía correo electrónico, o por cualquier otro medio, a personas naturales con quienes tiene o ha tenido relación, tales como, sin que la enumeración signifique limitación, trabajadores y familiares de éstos, accionistas, consumidores, clientes, distribuidores, proveedores, acreedores y deudores, para las finalidades antes mencionadas.
  Las personas naturales cuyos Datos Personales sean objeto de Tratamiento por parte de LA EMPRESA, tienen los siguientes derechos, los cuales pueden ejercer en cualquier momento:
                    
  ● Conocer los Datos Personales sobre los cuales LA EMPRESA está realizando el Tratamiento. De igual manera, el Titular puede solicitar en cualquier momento, que sus datos sean actualizados o rectificados, por ejemplo, si encuentra que sus datos son parciales, inexactos, incompletos, fraccionados, induzcan a error, o aquellos cuyo Tratamiento esté expresamente prohibido o no haya sido autorizado.
                    
  ● Solicitar prueba de la autorización otorgada a LA EMPRESA para el Tratamiento de sus Datos Personales.
                    
  ● Ser informado por LA EMPRESA, previa solicitud, respecto del uso que ésta le ha dado a sus Datos Personales.
                    
  ● Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones a lo dispuesto en la Ley de Protección de Datos Personales.
                    
  ● Solicitar a LA EMPRESA la supresión de sus Datos Personales y/o revocar la autorización otorgada para el Tratamiento de los mismos, mediante la presentación de un reclamo, de acuerdo con los procedimientos establecidos en el numeral 11 de la Política de Protección de Datos Personales de ANHEUSER-BUSCH INBEV S.A S.A. No obstante, la solicitud de supresión de la información y la revocatoria de la autorización no procederán cuando el Titular de la información tenga un deber legal o contractual de permanecer en la Base de Datos y/o Archivos, ni mientras se encuentre vigente la relación entre el Titular y LA EMPRESA, en virtud de la cual fueron recolectados sus datos.
                    
  ● Acceder de forma gratuita a sus Datos Personales objeto de Tratamiento.
Los invitamos a conocer la Política de Protección de Datos Personales de ANHEUSER-BUSCH INBEV S.A S.A., la cual incluye los procedimientos para que los Titulares de Datos Personales puedan ejercer sus derechos a conocer, actualizar, rectificar y suprimir la información y revocar la autorización, y se encuentra disponible para su consulta en el sitio web www.ANHEUSER-BUSCH INBEV S.A.co.`,

    TEST: 'Prueba'
  },
  [Locale.English]: {
    LOGIN_MESSAGE: 'We welcome you!',
    SHARP_ID: 'Sharp ID',
    SHARP_ID_PLACEHOLDER: 'Enter your Sharp ID',
    PASSWORD_PLACEHOLDER: 'Enter your password',
    NEED_HELP: 'Do yo need help?',
    NO_LINK: 'I did not receive the recovery link',
    EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Enter your email',
    HAVE_ACCOUNT: 'Do you already have an account?',
    ID_DOCUMENT: 'ID Document',
    ID_DOCUMENT_TIP: 'Input here your national document ID (DNI,CC,CURP)',
    NO_ACCOUNT: 'I do not have an account yet',
    VERIFICATION_CODE: 'Verification Code',
    INVALID_BIRTH_DATE_ERROR: 'Invalid birth date or verification link.',
    CODE_VERIFICATION_SUCCESS: 'Your account has been successfully verified.',
    USER_REGISTERED_SUCCESS:
      'We have sent you a verification code to your email so you can activate your account.',
    ERROR_REGISTERING_USER:
      'There was an error while trying to register the user.',
    EMPLOYEE_ID: 'Employee ID',
    SIGN_UP: 'Sign Up',
    VERIFY_CODE: 'Verify Code',
    VERIFY_CODE_MESSAGE: 'Now select your birth date to verify your account.',
    CALCULATE_YOUR_COMPENSATION: 'Calculate your compensation',
    WITHDRAW_YOUR_SALARY_WITH_MINU: 'Withdraw your salary with minu',
    REVIEW_VACATIONS: 'Review vacations status',
    BIRTH_DATE: 'Birth Date',
    BIRTH_DATE_PLACEHOLDER: 'Select your birth date.',
    MY_COMPENSATION: 'My compensation',
    YOUR_COMPENSATION: 'Your compensation',
    VACATIONS: 'Vacations',
    BENEFITS: 'Benefits',
    BENEFITS_INSTRUCTIONS:
      'Select a category or search for a keyword to start enjoying great benefits and discounts.',
    CERTIFICATES: 'Certificates',
    ERROR_FETCHING_COMPENSATION:
      'There was an error while trying to get the compensation data.',
    ERROR_FETCHING_BONUS:
      'There was an error while trying to get the bonus compensation formula.',
    COMPENSATION_P: 'Know the details of your annual compensation.',
    COMPENSATION_ITEM1: 'Enter your base monthly salary.',
    USER_SUPPORT: 'User support',
    MY_PAYROLL_RECEIPT: 'My payroll receipt',
    GRATIFICATIONS: 'Gratificaciones',
    VIEW_BENEFITS: 'View benefits',
    CALCULATE_BONUS: 'Calculate Bonus STI',
    RESULTS: 'Results',
    NO_RESULTS_INSTRUCTIONS:
      'We did not find results for “{textFilter}”. Check the grammar or use more general words.',
    START_AGAIN: 'Start again',
    BENEFIT: 'Benefit',
    AGREEMENT: 'Agreement',
    BENEFITS_MODAL_TITLE1: 'What is a benefit?',
    BENEFITS_MODAL_TEXT1:
      'You receive the benefits for being part of the company and are included in your job offer.',
    BENEFITS_MODAL_TITLE2: 'What is a convention?',
    BENEFITS_MODAL_TEXT2:
      'The agreements are discounts that you can access with external companies for being part of ABI.',
    PROVIDER: 'Provider',
    CONTACT: 'Contact',
    VIEW_MORE_BENEFITS: 'View more benefits',
    PHONE: 'Phone',
    ADDRESS: 'Address',
    WEBSITE: 'Website',
    MY_PROFILE: 'My Profile',
    COMPANY: 'Company',
    VICE_PRESIDENCY: 'Vice-presidency',
    AVATAR_UPLOAD_SUCCESS:
      'Your profile picture has been successfully updated.',
    AVATAR_UPLOAD_ERROR: 'There was an error updating your profile picture.',
    UPDATE_PICTURE: 'Update picture',
    EDIT_PROFILE: 'Edit profile',
    REPORT_ERROR: 'Report error',
    REPORT_ERROR_TITLE: 'Some error on your personal information?',
    REPORT_ERROR_TEXT: 'Tell us, where is the problem?',
    REPORT_ERROR_INSTRUCTION: 'DESCRIBE THE ERROR',
    REPORT_ERROR_PLACEHOLDER:
      'Hello! I found an error on my personal information in the platform…',
    REPORT_ERROR_ERROR:
      'There was an error while trying to send the error report.',
    ERROR_REPORT_SENT_TITLE: 'Thanks for your report!',
    ERROR_REPORT_SENT_BODY:
      'Our support team will review the information available to update your information as soon as possible.',
    EDIT_PROFILE_SUCCESS:
      'Your profile has been successfully updated. If you changed your email, we will send you an email.',
    EDIT_PROFILE_ERROR:
      'There was an error while trying to update your profile.',
    SAVE_CHANGES: 'Save changes',
    MY_PREFERRED_NAME: 'My preferred name',
    CANCEL: 'Cancel',
    CHANGE_PWD: 'Change password',
    CURRENT_PWD: 'Current password',
    CHANGING: 'Changing',
    ERROR_FETCHING_CATEGORIES:
      'There was an error while trying to fetch the benefit categories.',
    ERROR_FETCHING_BENEFITS:
      'There was an error while trying to fetch the benefits.',
    CALCULATE: 'Calculate',
    MONTHS: 'Months',
    CALCULATE_COMPENSATION: 'Calculate Compensation',
    ANNUAL_TOTAL: 'Annual Total',
    MONTHLY_SALARY_BASE: 'Monthly Salary Base',
    MONTHLY_SALARY_BASE_HELP:
      'The base pay that your receive monthly for your work.',
    BAND_HELP: 'Is a range of salaries for each level inside ABI.',
    TOTAL_ACHIEVEMENT_SCORE_HELP:
      'It is the percentage that takes into account the overall results, the BU and your individual annual goals.',
    BONUS_TARGET_HELP:
      'It is the percentage that takes into account the global results, the BU and the individual goals of the director of your area',
    MARKET_SALARY_RATE_HELP:
      'It is the base annual payment that a position pays according to the Market Median. Each band has its own MRS. ',
    BONUS_SIMULATOR: 'Bonus Simulator STI',
    BONUS_ESTIMATION: 'Bonus Estimation',
    TOTAL_ACHIEVEMENT_SCORE: 'Total Achievement Score',
    INDIVIDUAL_ACHIEVEMENT: 'Individual Achievement',
    INDIVIDUAL_ACHIEVEMENT_HELP:
      'They are composed of types of numerical, nominal, project or dashboard goals that are calculated according to the result assigned to your role. If you are band I to IV you must obtain a minimum of 35% to be eligible for the bonus, while if you are band V or higher the minimum is 50%. ',
    DISCRETIONARY_INCENTIVE: 'Discretionary Incentive',
    DISCRETIONARY_INCENTIVE_HELP:
      'It is an incentive determined by the vice president of each function to retain talent. It is distributed according to meritocracy criteria, where 15% of the population could have between 20% and 30% additional bonus, where this surplus is financed from the bonus of people with low performance.',
    SIZE_OF_THE_PIE: 'Size of the Pie',
    SIZE_OF_THE_PIE_HELP:
      'Determines the amount of funds that are available for the bonus and is calculated by the organic growth of EBITDA. It ranges from 40% to 160%.',
    ENTITY_PERFORMANCE: 'Entity Performance',
    ENTITY_PERFORMANCE_HELP:
      'It is the contribution of the entity to the general performance of the company.',
    ENJOY_YOUR_BENEFITS: 'Enjoy your benefits',
    CALCULATE_BONUS_STI: 'Calculate your Bonus STI',
    YOUR_PAYROLL_RECEIPTS: 'Your payroll receipts',
    YOUR_EMPLOYMENT_CERTIFICATES: 'Your employment certificates',
    VACATION_DAYS: 'Vacation Days',
    ANNUAL_VACATION_DAYS: 'Annual vacation days',
    ANNUAL_VACATION_DAYS_HELP:
      'Enter the vacation days to which you are currently entitled according to your seniority. This helps us calculate your vacation premium.',
    EMAIL_CHANGE_SUCCESS:
      'Your new email has been correctly verified in the platform.',
    EMAIL_CHANGE_ERROR:
      'There was an error while trying to verify the email change in the platform.',
    EMAIL_CHANGE_UNAUTHORIZED:
      'The link to verify your email has expired, you must make the request and verify it again.',
    WAIT_VERIFY_EMAIL: 'Please wait while we verify your email change.',
    BENEFITS_TOTAL: 'Benefits Total',
    BENEFITS_P:
      'The following values represent the cost of some of the benefits you receive from the company.',
    BENEFITS_P2:
      'Consult the complete list of benefits and agreements in the Benefits section.',
    BONUS_STI_TOTAL: 'Bonus STI Total',
    BONUS_SIMULATOR_P:
      'The short-term incentive is the value that the company recognizes to its workers with the payment of additional days of salary according to the Achievement Score of the area to which you belong. This calculation is a simulation. You can generate different estimates depending on the values entered.',
    CALCULATE_SCORE: 'Calculate Score',
    TIME_DEDICATION_RATE_P1:
      'It is the time you have within that period in the company.',
    TIME_DEDICATION_RATE_P2: 'Employees are not eligible for bonus if:',
    TIME_DEDICATION_RATE_P2_1:
      'They leave the company voluntarily before December 31 of the current year.',
    TIME_DEDICATION_RATE_P2_2:
      'Enter the company from October 1 of the current year',
    TIME_DEDICATION_RATE_P2_3:
      'They are fired for ethical, compliance or disciplinary reasons.',
    TIME_DEDICATION_RATE_P2_4:
      'They leave the company before having worked at least 6 months',
    TIME_DEDICATION_RATE_P3: 'Income Eligibility Rules',
    TIME_DEDICATION_RATE_P3_1:
      'If the employee joins the company or is eligible for the bonus for the first time before March 31, the bonus will be calculated for 100% of the year.',
    TIME_DEDICATION_RATE_P3_2:
      'If the employee joins the company or is eligible for the bonus for the first time from April 1 to September 30, the bonus will be calculated by the proportion of the year that he has worked. Ex: If you worked since July 1, you will be eligible for 50% of the bonus because it is 50% of the time. ',
    TIME_DEDICATION_RATE_P4: 'Position Change Eligibility Rules',
    TIME_DEDICATION_RATE_P4_1: 'If the employee changes position.',
    TIME_DEDICATION_RATE_P4_2:
      'Before March 1, 100% of your STI bonus will be calculated with the new goals.',
    TIME_DEDICATION_RATE_P4_3:
      'Between April 1 and September 30, the calculation of your bonus will be proportional to the time you had the initial goals and the time you have the new goals.',
    TIME_DEDICATION_RATE_P4_4:
      'Both spaces will be calculated with the band you have as of September 30.',
    TIME_DEDICATION_RATE_P4_5:
      'After October 1, the calculation of 100% of the bonus will be based on the previous goals and with the band that it has as of September 30.',
    STI_FORMULA: 'STI Formula',
    STI_FORMULA_HELP:
      'This tool was designed to help understand the calculation of the annual bonus and provide an estimate based on individual and company results. These simulations do not commit the company to any payment and are gross values, that is, they do not calculate the deduction of the respective statutory taxes. The annual bonus for the fiscal year will be paid in March of the following year, if any. The company reserves the right to change the formulas or variables of the annual bonus when it deems it necessary.',
    STI_FORMULA_P: 'This is how your bonus is calculated.',
    ANNUAL_TOTAL_HELP:
      'This tool was designed to help the understanding of the calculation of the Total Annual Compensation of each employee. These simulations do not commit the company to any payment and are gross values, that is, they do not calculate the deduction of the respective statutory taxes. The company reserves the right to change the Compensation model when it deems it appropriate. ',
    BENEFITS_TOTAL_HELP:
      'The values corresponding to the benefits are a reference of the cost of the same per employee. Failure to deliver one does not commit the Company to pay for it. The company reserves the right to change them when it deems appropriate.',
    PLEASE_SELECT_COUNTRY: 'Please select your country:',
    PORTAL_INSTRUCTIONS: 'Portal instructions',
    CATEGORY_BACK: 'Back to categories',
    FORMAT: 'Format',
    CONTROL_PANEL: 'Control Panel',
    ADMINISTRATION_PANEL: 'Administrator',
    USER_MANAGEMENT: 'User Management',
    UPLOAD_COLLABORATORS: 'Upload Collaborators',
    UPLOAD_EXITS: 'Upload Exits',
    USER_ADMIN_P1: 'Search users by ID, by name or use the filters.',
    USER_SEARCH_INSTRUCTIONS: 'Search users by name or by ID.',
    PERFORM_USER_SEARCH: 'Perform a user search.',
    ROLE: 'Role',
    FILTER: 'Filter',
    NONE: 'None',
    CHANGE_ROLE: 'Change Rol',
    DELETE_USERS: 'Delete users',
    DELETE_USERS_CONFIRMATION:
      'Are you sure that you want to delete the selected users permanently?',
    CHANGE: 'Change',
    CHANGE_ROLE_CONFIRMATION:
      'Are you sure that you want to change the rol for the selected users?',
    ERROR_FETCHING_USERS: 'There was an error while trying to fetch the users.',
    DELETE_USERS_SUCCESS: 'The users were deleted from the platform.',
    DELETE_USERS_ERROR:
      'There was an error while deleting the users from the platform.',
    SUCCESSFUL_UPLOAD: 'Successful Upload',
    COLLABORATORS_REPORT_SUCCESS:
      'The collaborators report has been successfully uploaded to the platform.',
    UNDERSTOOD: 'Understood',
    EXITS_REPORT_SUCCESS:
      'The exits report has been successfully uploaded to the platform.',
    COMPENSATION_DISCLAIMER:
      'Simulation based on an employ with local payroll. Results before taxes. Informative data, not official.',

    //
    HELP: 'Help',
    HELP_TITLE: 'How can we help you?',
    HELP_P1:
      'For questions about the use of the tool, please consult <a>the tutorials</a> that we created for you.',
    HELP_P2:
      'If after watching the tutorials you still have any questions or problems, contact us! Please help us to report your error in <a> this form </a> and we will contact you to resolve it.',
    HELP_P3:
      'For unresolved questions or support that were not resolved with the above options, go to <a>SAM Portal</a> and open a ticket. We will get back to you as soon as possible!',
    HOME: 'Home',
    PENDING: 'Pending',
    LOCATION: 'Location',
    COMPLETED_INTERVIEW: 'Completed Interview',
    REQUEST_HELP: 'Request Help',
    HELP_MAIL_SUBJECT: 'Help Request +BeneFi',
    HELP_MAIL_BODY: `Hello, it seems that you are having problems on our portal +BeneFi.

Please describe in detail what the error is, so our support team can find a solution as soon as possible.

Thank you for contacting us, we are here to help you.

Cordially,
Simplifica Maz Team`,

    PASSWORD_CHANGE_WARNING:
      'Your password is close to expire. You must change it {days, plural, =1 {today} other {in the following # days}}.',
    PASSWORD_BLOCKED_ERROR:
      'Your login has been temporarily blocked for multiple failed attempts. You may retry it in {minutes, plural, =0 {less than a minute} =1 {a minute} other {# minutes}}.',
    PASSWORD_VOID_ERROR:
      'Your current password has expired, you must use the forgot password mechanism to regain access to the platform.',
    INACTIVITY_WARNING:
      'This session will be close automatically for inactivity in {minutes} minutes.',
    REPORT_UPLOAD_SUCCESS:
      'The report has been uploaded successfully and it is being processed.',
    REPORT_UPLOAD_ERROR:
      'We are sorry! There was an error while uploading the report.',
    REPORT_LOAD_INSTRUCTIONS: 'Drag and drop the report file or click here',
    UPLOAD_REPORT: 'Upload Report',
    REPORT_LOAD: 'Report Load',
    ADMINISTRATION: 'Admin',
    EXISTING_USER: 'Existing User',
    ALL: 'All',
    GREETING: 'Hello {firstName}!',
    INIT_QUESTION: 'What do you want to do?',
    LOADING: 'Loading...',
    USER: 'User',
    PASSWORD: 'Password',
    OLD_PWD: 'Old password',
    MY_PWD: 'My password',
    SAVE_PWD: 'Save password',
    CLOSE_SESSION: 'Close session',
    FORGOT_PWD: 'Forgot password?',
    INIT_SESSION: 'Start Session',
    RETURN: 'Go back',
    SEND: 'Send',
    SEND_LINK: 'Send Link',
    NEW_PWD: 'New Password',
    NEW_PWD_PLACEHOLDER: 'Create new password',
    REPEAT_NEW_PWD: 'Repeat New Password',
    RECOVER_PWD: 'Recover Password',
    FORGOT_PWD_MESSAGE:
      'No problem. Write your email and we will send you a recovery link.',
    PASSWORD_RECOVERY_MESSAGE: 'Your password has been successfully changed.',
    FORGOT_PWD_NOTIFICATION:
      'We have sent to your email the instructions to recover your password.',
    CONTINUE: 'Continue',
    BACK: 'Back',
    REGISTER: 'Register',
    APPLY_INTERVIEW: 'Apply Interview',
    YES: 'Yes',
    NO: 'No',
    FINISH: 'Finish',
    SELECT: 'Select',
    JUSTIFICATION: 'Justification',
    ARE_YOU_SURE: 'Are you sure?',
    SAVING: 'Saving',
    FROM: 'From',
    UNTIL: 'Until',
    NAME_OR_ID: 'Name / ID',
    VIEW_REPORT: 'View Report',
    THANK_YOU: 'Thank You!',
    EARLY_ENDING: 'This interview concludes here.',
    ACCEPT: 'Accept',
    DOWNLOAD: 'Download',
    GENERATING_DOWNLOAD: 'Generating download...',
    REPORTS: 'Reports',
    USER_MANUAL: 'User Manual',
    USERS: 'Users',
    ADD: 'Add',
    EDIT: 'Edit',
    DELETE: 'Delete',

    ERROR_SESSION:
      'Oh! We could not log in with your username, please try again.',
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    PRIVACY_POLICY: 'Privacy Policy',
    COPYRIGHT: 'All rights reserved {year}. ©{year}ANHEUSER-BUSCH INBEV S.A.',
    NEW_INTERVIEW_STATUS: 'Register - step 1 / 3',
    NEW_INTERVIEW: 'New Interview',
    APPLICATION_DATE: 'Application Date',
    EMPLOYEE_NAME: 'Associate Name',
    SEX: 'Sex',
    LINE_MANAGER: 'Line Manager',
    BAND: 'Band',
    POSITION: 'Position',
    COUNTRY: 'Country',
    UEN: 'UEN',
    VP: 'Vice-Presidency / Area',
    VP_SHORT: 'VP / Area',
    HIRING_DATE: 'Hiring Date',
    OPR_RATING: 'OPR Rating',
    EXIT_DATE: 'Exit Date',
    EXIT_TYPE: 'Exit Type',
    AGREED_TO_INTERVIEW: 'Agreed to be interviewed?',
    EDIT_INFO: 'Edit information',
    VOLUNTARY: 'Voluntary',
    INVOLUNTARY: 'Involuntary',
    BP_OBSERVATIONS: 'Business Partner observations',

    INTERVIEW_INSTRUCTIONS_STATUS: 'Questionary - step 2 / 3',
    INTERVIEW_INSTRUCTIONS_TITLE:
      'You are about to go into the questions section.',
    INTERVIEW_INSTRUCTIONS_HEAD:
      'Remember that your job is to be an ambassador of AB InBev culture until the last moment, so it is important that you consider the following to perform this interview as humanly as possible:',
    INTERVIEW_INSTRUCTIONS_POINT_1:
      'Mention how much we appreciate all the experience shared with the company and the time he/she is taking to answer our questions.',
    INTERVIEW_INSTRUCTIONS_POINT_2:
      'Assure him/her that this information is 100% confidential. This means that no one besides you will know the answers, so there is no retaliation of any kind and this in no way will influence possible job references that are asked of him/her.',
    INTERVIEW_INSTRUCTIONS_POINT_3:
      'Let him/her know that the interview is intended to find areas of opportunity that will help us make ABInBev a better company to work for.',
    INTERVIEW_INSTRUCTIONS_BOTTOM:
      'Once the interview is over, it is of utmost importance that you once again thank them for their time, their responses and their honesty; in addition to wishing him/her good luck in his future projects.',

    QUESTIONARY_STATUS: 'Questionary - step 2 / 3',
    QUESTIONARY_TITLE: 'Exit Interview',
    QUESTIONARY_EXPLANATION:
      'Select the answer corresponding to what the collaborator said and provide comments when necessary in the space provided.',
    QUESTIONARY_CONFIRMATION:
      'Once you finish the interview, you will not be able to edit the answers in this section.',
    QUESTIONARY_THANKS_TITLE: 'Thank you very much',
    QUESTIONARY_THANKS_SUB_TITLE: 'for your time and collaboration!',

    // Common Options
    NA: 'N.A.',
    ALWAYS: 'Always',
    ALMOST_ALWAYS: 'Almost always',
    SOMETIMES: 'Sometimes',
    ALMOST_NEVER: 'Almost never',
    NEVER: 'Never',
    // Motive Options
    QUESTIONARY_MOTIVE_NA: 'N.A.',
    QUESTIONARY_MOTIVE_INCOME: 'Income',
    QUESTIONARY_MOTIVE_BENEFITS: 'Benefits',
    QUESTIONARY_MOTIVE_WORK_CENTER: 'Work center',
    QUESTIONARY_MOTIVE_WORK_ENVIRONMENT: 'Work environment',
    QUESTIONARY_MOTIVE_COMPANY_CULTURE: 'Company Culture',
    QUESTIONARY_MOTIVE_COMPANY_PRESTIGE: 'Company Prestige ',
    QUESTIONARY_MOTIVE_POSITION: 'Position / Function',
    QUESTIONARY_MOTIVE_OTHERS: 'Others',
    // Exit Motive Options
    EXIT_MOTIVE_NA: 'N.A. (involuntary departures)',
    EXIT_MOTIVE_IMMEDIATE_LEADER: 'Immediate Leader',
    EXIT_MOTIVE_INCOME: 'Income/Salary',
    EXIT_MOTIVE_LACK_OF_PROFESSIONAL_GROWTH: 'Lack of professional growth',
    EXIT_MOTIVE_LIFE_WORK_BALANCE: 'Work-life balance',
    EXIT_MOTIVE_COMPANY_CULTURE: 'Company culture',
    EXIT_MOTIVE_COMPANY_LEADERSHIP: 'Company leadership',
    EXIT_MOTIVE_COMPANY_PRESTIGE: 'Prestige/reputation of AbInBev',
    EXIT_MOTIVE_WORK_ENVIRONMENT: 'Work environment',
    EXIT_MOTIVE_RESPECT_AND_INCLUSION: 'Respect and inclusion',
    EXIT_MOTIVE_LACK_OF_TRAINING: 'Lack of training/development',
    EXIT_MOTIVE_SECURITY_OF_WORK_CENTER: 'Safety conditions in my work center',
    EXIT_MOTIVE_LACK_OF_RESOURCES_FOR_JOB:
      'Lack of necessary resources to do my job',
    EXIT_MOTIVE_DISLIKE_OF_JOB_TASKS: "Dislike of your role's tasks",
    EXIT_MOTIVE_PERSONAL_SITUATION: 'Personal situation',
    EXIT_MOTIVE_OTHER: 'Other',
    EXIT_MOTIVE_SUM_OTHERS: 'Sum (other motives)',

    PRE_FEEDBACK_STATUS: 'LM Feedback - step 3 / 3',
    PRE_FEEDBACK_CONTINUE: 'Continue with feedback',
    FEEDBACK: 'Feedback',
    EXIT: 'Exit',
    PRE_FEEDBACK_TEXT_1:
      'Now is the time to provide a feedback session to the Line Manager of our former collaborator.',
    PRE_FEEDBACK_TEXT_2:
      'In the next section you will find a space to record what happened during this session. You can complete it now or do it later, by accessing it from the "Pending interviews" section of the Menu.',
    PRE_FEEDBACK_QUESTION: 'What do you want to do?',

    FEEDBACK_STATUS: 'Feedback to LM - step 3 / 3',
    FEEDBACK_TITLE: 'Feedback to Line Manager',
    FEEDBACK_EXPLANATION:
      'Please complete the fields below. Remember that <b>all the information you fill out in this section will be shared directly with your Line Manager</b>.',
    FEEDBACK_ACTION_PRE_EXPLANATION: 'General description of the Action Plan',
    FEEDBACK_ACTION_POST_EXPLANATION:
      'Remember that this plan must be executed in the current Engagement Action Plan',
    FEEDBACK_BUTTON: 'Send to LM',
    FEEDBACK_CONFIRMATION:
      'Once you submit to LM, the information cannot be changed unless he/she requests it.',

    READY: 'Ready!',
    FEEDBACK_SENT_PARAGRAPH_1:
      'We have sent an email to the Line Manager where he/she can corroborate this information.',
    FEEDBACK_SENT_PARAGRAPH_2:
      'Once he/she gives us his/her confirmation, the interview will have concluded successfully. We will notify you when this happens. ',

    NOTICE_CONFIRMED_PARAGRAPH_1:
      'La entrevista de salida con ID <strong>{interviewId}</strong> ha concluido satisfactoriamente.',
    NOTICE_CONFIRMED_PARAGRAPH_2:
      'Gracias por ayudarnos a hacer de ABI un mejor lugar para trabajar.',

    NOTICE_DECLINED_PARAGRAPH_1:
      'We have notified your Business Partner that you do not agree with the provisions of your feedback to review your situation.',
    NOTICE_DECLINED_PARAGRAPH_2:
      'We ask that you try to contact him as soon as possible.',
    NOTICE_DECLINED_THANKS: 'Thanks for your cooperation!',

    LM_FEEDBACK_SENT_SUCCESS:
      'Your answer has been sent correctly. Thanks for your help!',
    LM_FEEDBACK_ALREADY_SENT_ERROR:
      'You have already decided on the feedback session.',
    LM_FEEDBACK_SENT_ERROR:
      'We are sorry! An error occurred while trying to send your answer.',

    /**
     * History
     */
    HISTORY: 'History',
    INTERVIEW_COUNT:
      '{interviewCount, plural, =0 {You have not conducted any interview} =1 {You have conducted 1 interview} other {You have conducted # interviews}} until now.',
    HISTORY_INSTRUCTIONS:
      'To consult them, filter by date range or search by collaborator name or ID.',

    HISTORY_COLUMN_SHARP: 'ID',
    HISTORY_COLUMN_EMPLOYEE: 'Employee',
    HISTORY_COLUMN_LINE_MANAGER: 'Line Manager',
    HISTORY_COLUMN_CREATED_AT: 'Creation Date',
    HISTORY_COLUMN_INTERVIEWER: 'Interviewer',
    HISTORY_COLUMN_COUNTRY: 'Country',
    HISTORY_COLUMN_VICE_PRESIDENCY: 'VP / Area',
    HISTORY_COLUMN_UEN: 'UEN',
    HISTORY_COLUMN_STATUS: 'Status',

    HISTORY_ROW_DISPLAY: '{from}-{to} to {count}',

    PENDING_INTERVIEWS: 'Pending Interviews',
    NO_PENDING_INTERVIEWS: 'You have 0 pending interviews.',

    INTERVIEW_STATUS_REGISTERED: 'Registered',
    INTERVIEW_STATUS_INTERVIEW: 'Interview',
    INTERVIEW_STATUS_FEEDBACK: 'Feedback to LM',
    INTERVIEW_STATUS_FEEDBACK_SENT: 'Feedback Sent',
    INTERVIEW_STATUS_FEEDBACK_REJECTED: 'Rejected - LM',
    INTERVIEW_STATUS_FEEDBACK_ACCEPTED: 'Completed - LM',
    INTERVIEW_STATUS_FEEDBACK_NOT_CONFIRMED: 'Completed',

    /**
     * Reports
     */
    REPORTS_INSTRUCTIONS: 'Select the information you need to generate a graph',
    PARAMETER: 'Parameter',
    PERIOD: 'Period',
    SHOW_BY: 'Show by',
    OPTIONAL: 'Optional',
    GENERATE_CHART: 'Generate chart',
    GENERATING: 'Generating...',
    REPORT_TYPE_KPI: 'KPI Compliance',
    REPORT_TYPE_SLA: 'Exit Motives',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    UPDATE_DATE: 'Update',
    ZONE: 'Zone',
    ANOTHER_REPORT: 'Do you need another report?',
    ANOTHER_REPORT_SUB: 'Download the Excel file that you need.',
    DOWNLOAD_REPORT: 'Download Report',
    DOWNLOAD_IMAGE: 'Download imagen',
    COMPLETED: 'Completed',
    UNANSWERED: 'Unanswered',
    IN_PROGRESS: 'In progress',
    REPORT_TYPE_KPI_TITLE: 'KPI',
    COMPLIANCE_PERCENTAGE: 'Compliance %',
    REPORT_TYPE_SLA_TITLE: 'Exit Motives',

    /**
     * Admin
     */
    ADMIN_SEARCH_INSTRUCTIONS:
      'Write here the ID or IDs of the users you want to add, separating them with a comma. Enter when finished ',
    USER_ADMIN_COLUMN_SHARP: 'ID',
    USER_ADMIN_COLUMN_NAME: 'Name',
    USER_ADMIN_COLUMN_COUNTRY: 'Country',
    USER_ADMIN_COLUMN_UEN: 'Company',
    USER_ADMIN_COLUMN_EMAIL: 'Email',
    USER_ADMIN_COLUMN_ROLE: 'Role',
    SUBMITTING_ADD: 'Adding...',
    SUBMITTING_EDIT: 'Modifying...',
    SUBMITTING_DELETE: 'Deleting...',
    USERS_UPDATE_SUCCESS: 'The selected users have been updated correctly.',
    USERS_UPDATE_ERROR:
      'We are sorry! There was an error while updating the selected users.',

    USER_ROLE_ADMINISTRATOR: 'Administrator',
    USER_ROLE_REGULAR: 'Collaborator',
    USER_ROLE_INVALID: 'Deleted',

    IMG_LOAD_INSTRUCTIONS: 'Drag and drop the image file or click here',

    /**
     * Autocomplete
     */
    AUTOCOMPLETE_NO_OPTIONS: 'There are no options for this search.',
    AUTOCOMPLETE_INSTRUCTIONS: 'Start to write to search.',

    /**
     * Validation
     */
    VALIDATE_EMAIL: 'The email you entered is not valid.',
    VALIDATE_TERMS: 'You must accept the terms and conditions.',
    VALIDATE_POLICY: 'You must accept the privacy policy',
    VALIDATE_REQUIRED_GENERIC: 'This field is required.',
    VALIDATE_REQUIRED: '{fieldName} is a required field.',
    VALIDATE_PWD_NOT_NEW:
      'The new password must be different than your current password.',
    VALIDATE_PWD_MATCH: 'Passwords must match.',
    VALIDATE_MIN_LENGTH:
      '{fieldName} must have at least {minLength} characters.',
    VALIDATE_PWD_INSTRUCTIONS:
      'Must have at least {length} characters, a number, a lower case letter, an upper case letter and a symbol (. @ $ ! % * # ? & -)',
    VALIDATE_CREDENTIALS_ERROR: 'Incorrect username or password.',
    VALIDATE_CURRENT_PWD: 'The current password is incorrect.',
    VALIDATE_MUST_SELECT_SCOPE: 'You must select a scope.',

    ERROR_FETCHING_COLLABORATOR:
      "We are sorry! There was an error downloading the collaborator's information",
    ERROR_CREATING_INTERVIEW:
      'We are sorry! There was an error creating the interview',
    ERROR_FETCHING_STORED_QUESTIONARY:
      'We are sorry! There was an error downloading the stored information about the interview.',
    ERROR_SAVING_PARTIAL_QUESTIONARY:
      'We are sorry! There was an error while saving the partial interview.',
    ERROR_SAVING_QUESTIONS:
      'We are sorry! There was an error while saving the questions.',
    ERROR_FETCHING_STORED_FEEDBACK:
      'We are sorry! There was an error while downloading the stored feedback for the interview.',
    ERROR_SAVING_PARTIAL_FEEDBACK:
      'We are sorry! There was an error while saving the partial feedback.',
    ERROR_SAVING_FEEDBACK:
      'We are sorry! There was an error while saving the feedback.',
    ERROR_DOWNLOADING_REPORT:
      '¡Lo sentimos! Hubo un error descargando el reporte.',
    ERROR_PAYROLL:
      'We are sorry! There was an error downloading the information',

    SUCCESS_CREATING_INTERVIEW: 'The interview has been created correctly.',
    SUCCESS_SAVING_QUESTIONS: 'The questions has been correctly saved.',
    SUCCESS_SAVING_FEEDBACK: 'The feedback has been correctly saved.',

    BUSINESS_UNIT_CAC: 'CAC',
    BUSINESS_UNIT_CO: 'Colombia',
    BUSINESS_UNIT_EC: 'Ecuador',
    'BUSINESS_UNIT_HN / SV': 'Honduras / Salvador',
    BUSINESS_UNIT_MEX: 'Mexico',
    BUSINESS_UNIT_PE: 'Peru',

    VP_SALES: 'Sales',
    VP_FINANCE: 'Finance',
    'VP_LEGAL / CORPORATE AFFAIRS': 'Legal',
    VP_LOGISTICS: 'Logistics',
    VP_SUPPLY: 'Supply',
    VP_SOLUTIONS: 'Solutions',
    VP_MARKETING: 'Marketing',
    VP_PROCUREMENT: 'Procurement',
    VP_PEOPLE: 'People',
    PHYSICAL: 'Physical',
    SOCIO_EMOTIONAL: 'Socio-Emotional',
    FINANCIAL: 'Finaciero',

    MANAGER_BENEFITS: 'Content management',

    PILLARFISICO: 'Physical',

    PAYROLL_NOT_DATA: 'There is no associated data, please try another date',
    PAYROLL_TITLE: 'Payroll voucher',
    TITLE_DESCRIBE: 'Select the month to download your payroll receipt',
    BTN_PAYROLL: 'Consult',
    PAYROLL_VOUCHER: 'Voucher',
    PAYROLL_MONTH: 'Month',
    PAYROLL_SELECTED: 'Select year and month',

    SESION_MODAL_TITLE: 'How nice to have you here!',
    SESION_MODAL_DESCRIBE: `Remember that if you are in {CO} or {RD}, you can visit {EB} or {tap}
    to see the benefits that the company has for you.`,
    SESION_MODAL_DESCRIBE_2:
      'If you are in {MX}, we want you to know that we continue working to enable the tool and everyone can access it.',

    PRIVACY: `ANHEUSER-BUSCH INBEV S.A. PUNTO A PUNTO T2, Cervezas Modelo Nvo. León, Diblo Corporativo, Cervezas Modelo Pacífico, MULTISERVICIOS NAC MODELO, COBRANZA MODELO, Cervezas Modelo Centro, Cervezas Modelo Occidente, Cervezas Modelo en S.L.P., Cervezas Mod.B.California, Cervezas Modelo Zacatecas, Dist.Cervezas en el Norte, Distribuidora de Tabasco, Cervezas Modelo Guerrero, Cerv.Modelo Zona Metrop., Cervezas Modelo en Sonora, Cervezas Modelo del Bajío, Cervezas Modelo Altiplano, Cervezas Modelo Morelos, Cervezas Modelo Campeche, Cervezas Modelo en Oaxaca, Cervezas Modelo Sureste, Cervezas Modelo Hidalgo, Cervezas Modelo Nayarit, Cervezas Modelo Michoacán, Cervezas Modelo Edo.Mex., Inamex Cerveza y Malta, Agencia Modelo del Istmo, Cerv. Mod. de Guadalajara, Cía.Cervecera del Trópico, CERVECERIA YUCATECA, Cerv Modelo (México), Cebadas y Maltas, Cerveceria Modelo Centro Dist. Modelo en Chihuahua, Cervezas Modelo Acapulco Envases de Zacatecas, Cerv. Modelo de Torreón Tapas y Tapones Zacatecas, Cervecería del Pacífico, Cervezas Modelo Noreste Cervezas Modelo Veracruz Cia.Cerv. de Zacatecas, Ind Vidriera del Potosí Dist PacíficoMod Culiacán, ARTESANAS DE MALTA Y CEBA Rancho Cermo, SA de CV Distrib Industrial Cuicha Materiales del Istmo, S.A Ind Decoradora de Envases Empresarios Detallistas d Bavaria S.A. ZX Ventures Colombia Kopps Commercial S.A.S. Cerveceria Union S.A. Cerveceria del Valle S.A. Impresora Del Sur S.A. Indugral Cerv BBC de la Sabana SAS Transportes TEV S.A.S. Cerveceria BBC SAS Fundacion Bavaria La Constancia LTDA DE CV Cerv Hondureña, S.A. Plásticos Indust HN, S.A. Logístic Integral HN S.A. Cervecería Nacional SdeRL MAR DEL SUR LOGÍSTICA, SA PACIFIC BREWERY, S.A. COMPAÑÍA CERVECERA AMBEV UCP BACKUS Y JOHNSTON SAA CERVECERIA SAN JUAN S.A. NAVIERA ORIENTE S.A.C TRANSPORTES 77 S.A. Ambev Centroamerica DINADEC S.A. Cervecería Nacional CN SA Cervecería Nac. Dominican Banks Brewery Banks Holding Limited Barbados Diary Industries Dominica Brewery & Bevera Saint Vincent Brewery & B, all with e-mail protecciondedatos@co.ab-inbev.com, and telephone (+571) 6389000 (hereinafter THE COMPANY), each one individually considered as Responsible for the Processing of Personal Data, for the adequate development of its commercial activities, as well as for the strengthening of its relations with third parties, collects, stores, uses, circulates and deletes Personal Data corresponding to natural persons with whom it has or has had a relationship, such as, without the enumeration meaning limitation, workers and their relatives, shareholders, consumers, customers, distributors, suppliers, creditors and debtors. 
 
  • The Personal Data are processed by THE COMPANY for the following purposes:

  • To send information to its employees and family members; 

  • For the provision of health services to family members of employees of THE COMPANY who are beneficiaries of the health service; 

  • For the recognition, protection and exercise of the rights of the COMPANY's shareholders; 

  • For the strengthening of relationships with its consumers and customers, by sending relevant information, taking orders and attention to Petitions, Complaints and Claims (PQR's) by the customer service area, the evaluation of the quality of its customer service and the invitation to events organized or sponsored by THE COMPANY, among others; 

  • For the interaction with its Distributors, for the verification of compliance with distribution standards, its legal obligations with its workers and for the invitation to events organized or sponsored by THE COMPANY, among others. 

  • To consolidate a timely and quality supply with its Suppliers, through the invitation to participate in selection processes, the evaluation of compliance with their obligations and the invitation to events organized or sponsored by THE COMPANY, among others; 

  • For the verification of balances of its creditors; 

  • For the determination of outstanding obligations, the consultation of financial information and credit history and the report to information centers of unfulfilled obligations, with respect to its debtors; 

  • To improve, promote and develop its products and those of its related companies worldwide; 

  • For marketing activities, statistics, research and other commercial purposes that do not contravene the legislation in force; 

  • For the attention of judicial or administrative requirements and compliance with judicial or legal mandates. 

  • To eventually contact, via e-mail, or by any other means, natural persons with whom it has or has had a relationship, such as, but not limited to, employees and their relatives, shareholders, consumers, customers, clients, distributors, suppliers, creditors and debtors, for the aforementioned purposes. 

  • The natural persons whose Personal Data are subject to Processing by THE COMPANY, have the following rights, which may be exercised at any time: 

  • To know the Personal Data on which THE COMPANY is performing the Processing. Similarly, the Data Subject may request at any time, that their data be updated or rectified, for example, if they find that their data is partial, inaccurate, incomplete, fractioned, misleading, or those whose Processing is expressly prohibited or has not been authorized. 

  • Request proof of the authorization granted to THE COMPANY for the Processing of your Personal Data. 

  • To be informed by THE COMPANY, upon request, regarding the use it has given to their Personal Data. 

  • To file before the Superintendence of Industry and Commerce complaints for violations to the provisions of the Personal Data Protection Law. 
                    
Request to THE COMPANY the deletion of their Personal Data and/or revoke the authorization granted for the Processing thereof, by filing a claim, in accordance with the procedures set forth in paragraph 11 of the ANHEUSER-BUSCH INBEV S.A S.A. Personal Data Protection Policy. However, the request for deletion of the information and the revocation of the authorization shall not proceed when the Holder of the information has a legal or contractual duty to remain in the Database and/or Files, nor while the relationship between the Holder and the COMPANY, by virtue of which the data were collected, is still in force. 
                    
Access free of charge to their Personal Data subject to Processing. 
                    
We invite you to know the Personal Data Protection Policy of ANHEUSER-BUSCH INBEV S.A S.A., which includes the procedures for the Personal Data Owners to exercise their rights to know, update, rectify and delete the information and revoke the authorization, and is available for consultation on the website www.ANHEUSER-BUSCH INBEV S.A.co. `,

    TEST: 'Test'
  }
}

const keys = {}
export const TranslationKey = Object.keys(translations[Locale.Spanish]).reduce(
  (obj: typeof keys, key: string): typeof keys => ({
    ...obj,
    [key]: key
  }),
  keys
) as {
  [key in keyof (typeof translations)[Locale.Spanish]]: string;
}

export default translations
